module.exports = __webpack_public_path__ + "img/scale-01.2f66807a.svg";